export const CoconutType = {
  Lead: 'Lead',
  Retail: 'Retail',
  Note: 'Note',
  Task: 'Task',
  Beneficiary: 'Beneficiary',
  Corporate: 'Corporate',
  Registration: 'Registration',
  TrustedAPIRegistration: 'TrustedAPIRegistration',
  TrustedAPIQuote: 'TrustedAPIQuote',
  TransactionalAPIQuote: 'TransactionalAPIQuote',
  Lookup: 'Lookup',
  Permission: 'Permission',
  User: 'User',
  Document: 'Document',
  Setting: 'Setting',
  History: 'History',
  KYC: 'KYC',
  RateAlert: 'RateAlert',
  Payment: 'Payment',
  IFTI: 'IFTI',
  Conversion: 'Conversion',
  Transaction: 'Transaction',
  ComplianceNote: 'ComplianceNote',
  RiskSetting: 'RiskSetting',
  SMR: 'SMR',
  Notification: 'Notification',
  PricingPlan: 'PricingPlan',
  Affiliate: 'Affiliate',
  Opportunity: 'Opportunity',
  CustomerNotification: 'CustomerNotification',
  LeadDistribution: 'LeadDistribution',
  PricingStructure: 'PricingStructure',
  BulkPayment: 'BulkPayment',
  Transfer: 'Transfer',
  SalesOpportunity: 'SalesOpportunity',
  IncomingFund: 'IncomingFund',
  LedgerAccount: 'LedgerAccount',
  InternalAccount: 'InternalAccount',
  VirtualAccount: 'VirtualAccount',
  MarketingSettings: 'MarketingSettings',
};
